import { types } from '../types';
import { createAction, createReducer } from '@reduxjs/toolkit';

const currentSite = createAction(types.SET_CURRENTSITE);
const landingPage = createAction(types.SET_LandingPage);
const UserDetails = createAction(types.SET_UserDetails);
const currentTimeZone = createAction(types.SET_TIMEZONE);
const menuCollapse = createAction(types.SET_MenuCollapse);
const menuHierarchy = createAction(types.SET_MENUHIERARCHY);
const menuSelected = createAction(types.SET_MENU_SELECTION);
const userCurrentMenu = createAction(types.USER_CURRENT_MENU);
const DefaultHierarchy = createAction(types.GET_DefaultHierarchy);
const loggedInProfile = createAction(types.GET_LOGGEDIN_PROFILE_SUCCESS);
const userTimeout = createAction(types.SET_DEFAULTIMEOUT);

const initialState = {
  loggedInProfile: {},
  menuHierarchy: {},
  landingPage: '',
  UserDetails: {},
  DefaultHierarchy: {},
  menuCollapse: false,
  currentTimeZone: 'Asia/Kolkata',
  menuSelected: [],
  userTimeout: 30
};

const Login = createReducer(initialState, (builder) => {
  builder
    .addCase(loggedInProfile, (state, action) => {
      state.loggedInProfile = action.layout;
    })
    .addCase(userTimeout, (state, action) => {
      state.userTimeout = action.userTimeout;
    })
    .addCase(menuHierarchy, (state, action) => {
      state.menuHierarchy = action.layout;
    })
    .addCase(currentSite, (state, action) => {
      state.currentSite = action.layout;
    })
    .addCase(currentTimeZone, (state, action) => {
      state.currentTimeZone = action.layout;
    })
    .addCase(landingPage, (state, action) => {
      state.landingPage = action.layout;
    })
    .addCase(UserDetails, (state, action) => {
      state.UserDetails = action.layout;
    })
    .addCase(menuCollapse, (state, action) => {
      state.menuCollapse = action.layout;
    })
    .addCase(DefaultHierarchy, (state, action) => {
      state.DefaultHierarchy = action.layout;
    })
    .addCase(menuSelected, (state, action) => {
      state.menuSelected = action.menuHierarchy;
    })
    .addCase(userCurrentMenu, (state, action) => {
      state.userCurrentMenu = action.menuCode;
    })
    .addDefaultCase(() => {});
});

export default Login;
